export const DeviceSize = {
    mobile: 1377,
    tablet: 992,
    laptop: 1324,
    desktop: 2024,
  };
  